import { createFileRoute } from "@tanstack/react-router";
import { redirectTo } from "@/lib/route-redirect";
export const Route = createFileRoute("/marketing/social-media-marketing")({ beforeLoad: redirectTo("/marketing/social-content") });
